<template>
    <!--查詢床位狀況-->
    <v-flex row wrap xs12 sm12 md12 lg12 ml-1 mr-1>
        <v-flex class="xs12 sm12 md8 lg8 pr-3">

            <input v-model="inputDate" style="border:1px solid black;margin-left: 10px" id="inputDate" type="date" :max="inputMaxDate" >  <v-btn @click="searchBed" middle class="pl-1 pr-1 mr-2 regFRBtn">查詢</v-btn>

            <v-flex xs12 sm12 md12 lg12 mt-2 pr-2>
                <table style="width: 100%" class="clinicTableOutline  elevation-2 ml-2 mr-2">
                    <thead class="clinicNoThead">
                    <tr>
                        <th class="clinicNoTh">護理站別</th>
                        <th class="clinicNoTh">總床數</th>
                        <th class="clinicNoTh">佔床數</th>
                        <th class="clinicNoTh">空床數</th>
                        <th class="clinicNoTh">佔床率</th>

                    </tr>
                    </thead>
                    <tbody>
                    <template>
                        <tr   v-for="(item,index) in bedList" :key="index">
                            <td :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="text-center clinicNoTd">
                                <v-flex :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="clinicNoTdDiv">
                                    {{item.staNsName}}
                                </v-flex>
                            </td>
                            <td :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="text-center clinicNoTd">
                                <v-flex :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="clinicNoTdDiv">
                                    {{item.totBed}}
                                </v-flex>
                            </td>
                            <td :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="text-center clinicNoTd">
                                <v-flex :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="clinicNoTdDiv">
                                    {{item.occBed}}
                                </v-flex>
                            </td>
                            <td :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="text-center  clinicNoTd">
                                <v-flex :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="clinicNoTdDiv">
                                    {{item.empBed}}
                                </v-flex>
                            </td>
                            <td :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="text-center  clinicNoTd">
                                <v-flex :style="{color:item.staNsName=='合計'?'red':'',fontWeight:item.staNsName=='合計'?'bold':''}" class="clinicNoTdDiv">
                                    {{item.occRate+'%'}}
                                </v-flex>
                            </td>
                        </tr>
                    </template>



                    </tbody>

                    <tfoot class="hidetfoot" style="margin-bottom: 20px;">
                    <tr >
                        <td colspan="5" class="clinicNoTd" v-html="bedStatus1"> </td>
                    </tr>
                    <!--<tr>-->
                        <!--<td colspan="5" class="clinicNoTd"> ※2.每日病床數更新(住床數、空床數、佔床率)</td>-->
                    <!--</tr>-->

                    </tfoot>
                </table>

            </v-flex>
        </v-flex>

        <v-flex class="xs12 sm12 md4 lg4 pr-3">
            <span v-html="bedStatus2"></span>
            <!--<span style="font-weight: bold;font-size: 1.2rem">註:</span><br/>-->
            <!--1. 本公告之床位以前一日凌晨止及報備健保局資料為計算公告基礎，排除嬰兒床、洗腎床、日間照護床、急診留觀床。-->
            <!--<br/>-->
            <!--2. 床位的使用需要考量性別、疾病分類等問題-->
            <!--<br/>-->
            <!--3. 所公告之明細是以辦理電腦住院登記完成為基礎，尚未包括門、急診及預約住院候床之病患。-->
        </v-flex>

        <v-dialog v-model="errorDialog"
                  persistent
                  :width="dialogWidth+'%'"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <alert-win @closeDialog="closeErrorDialog" @confirm="errConfirm" :alery-type="aleryType"  :alert-title="errorTitle" :alert-msg="errorContent" ></alert-win>
        </v-dialog>


        <v-dialog
                v-model="loading"
                hide-overlay
                persistent
                width="300"
        >
            <v-card
                    color="primary"
                    dark
            >
                <v-card-text>
                    資料統計中，請稍後
                    <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>

    </v-flex>

</template>

<script>
    import AlertWin from '../inursingsys/AlertWin'
    export default {
        name: "BedUsageRate",
        components:{AlertWin},
        data() {
            return {
                inputDate:'',
                bedList:[],
                loading:false,
                errorDialog:false,
                errorTitle: '',
                errorContent:'',
                aleryType:'error',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                noticeInfo:'',
                inputMaxDate:'',
                bedStatus1:'',
                bedStatus2:'',

            }
        },
        computed:{
            dialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {return width = 100}
                if(this.$vuetify.breakpoint.sm == true){return width = 97}
                if(this.$vuetify.breakpoint.md == true){return width = 55}
                if(this.$vuetify.breakpoint.lg == true){return width = 45}
                if(this.$vuetify.breakpoint.xl ==true){return width = 40}
                return  width
            },
        },
        created(){
            let procDate = new Date();
            procDate.setDate(procDate.getDate()-1); //包含當天
            this.inputMaxDate = this.$UtilityJs.AD2ROC_DateTime(new Date(procDate).toISOString(), 'date');
            this.inputDate = this.inputMaxDate;
            let replaceDate = this.inputDate.replace(new RegExp("-", 'g'), "");
            let yyy = (replaceDate.substring(0,4))-1911
            let mmdd = replaceDate.substring(4,8)
            this.axios_getBedList(yyy+""+mmdd);
            this.axios_getBedStatus1();//表格內文字1
            this.axios_getBedStatus2();//表格外文字1

        },
        watch: {
            '$route.params': function () {
                let procDate = new Date();
                procDate.setDate(procDate.getDate()-1); //包含當天
                this.inputMaxDate = this.$UtilityJs.AD2ROC_DateTime(new Date(procDate).toISOString(), 'date');
                this.inputDate = this.inputMaxDate;
                let replaceDate = this.inputDate.replace(new RegExp("-", 'g'), "");
                let yyy = (replaceDate.substring(0,4))-1911
                let mmdd = replaceDate.substring(4,8)
                this.axios_getBedList(yyy+""+mmdd);
            },
        },
        methods:{
            findSelfCostBed(){
                return this.bedList.filter((i) => {
                    return (i.staNsName.indexOf("自費")>-1) ;
                })
            },
            searchBed(){
                let replaceDate = this.inputDate.replace(new RegExp("-", 'g'), "");
                if(replaceDate!==""){
                    let yyy = (replaceDate.substring(0,4))-1911
                    let mmdd = replaceDate.substring(4,8)
                    this.axios_getBedList(yyy+""+mmdd);
                }else {
                    alert("請輸入查詢日期")
                }

            },
            closeErrorDialog(){
                this.errorDialog = false;
            },
            errConfirm(){
                this.closeErrorDialog();
            },
            axios_getBedList(sDate){
                this.bedList  =[];
                this.noticeInfo = "";
                this.loading = true;
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let startDate = sDate;
                let url = this.$store.state.AppSetting.backSrvUrl+'snsinfom/datasearch/'+zone+"/"+startDate

                this.$http.get(url).then(response=>{

                    // this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
                        this.bedList  = response.data.resultSet[0].detailList;
                        let selfCost = this.findSelfCostBed();
                        if(selfCost.length==1){
                            let noSelf = response.data.resultSet[0].sumTotBed - selfCost[0].totBed;
                            let total = response.data.resultSet[0].sumTotBed
                            this.noticeInfo = ((noSelf/total)*100).toFixed(2)+"% " +"("+noSelf+"/"+total+")"
                           //健保床數量(減掉自費床 總床數) /總數量 data.resultSet[0].sumTotBed
                        }
                        this.loading = false;
                        this.bedList.push({
                            staNsName:"合計",
                            totBed:response.data.resultSet[0].sumTotBed, //總床數
                            occBed:response.data.resultSet[0].sumOccBed, //佔床數
                            empBed:response.data.resultSet[0].sumEmpBed, //空床數
                            occRate:response.data.resultSet[0].sumOccRate, //佔床率
                        })
                        // this.snStatus=true;
                        // this.snText = response.data.resultSet[0].rtnMessage;


                    }else if(response.data.resultSet.length==0&& response.data.hasOwnProperty('resultSet')&&response.data.status=='INFO'){
                        this.bedList  =[];
                        this.errorDialog = true;
                        this.errorTitle = "訊息";
                        this.errorContent = '<div style="color: red">'+response.data.message+'</div>';
                        this.loading = false;
                    }else {
                        this.bedList  =[];
                        this.errorDialog = true;
                        this.errorTitle = "訊息";
                        this.errorContent = '<div style="color: red">'+ response.data.message+'</div>';
                        this.snStatus=true;
                        this.snText = response.data.message;
                        this.loading = false;
                    }

                }).catch(error =>{
                    this.bedList  =[];
                    this.loading = false;
                    try {
                        let errorMsg = error.response.data.message==undefined?error.response.data.status:error.response.data.message;
                        switch (error.response.status){
                            case 300:
                            case 400:
                            case 401:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent = '<div style="color: red;font-size: 1.2rem;font-weight: bold">'+ errorMsg+'</div>';
                                break;
                            case 404:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent ="找不到頁面";
                                break;
                            case 500:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent = "伺服器錯誤";
                                break;
                            default:
                                this.errorDialog = true;
                                this.errorTitle = "訊息";
                                this.errorContent ='<div style="color: red;font-size: 1.2rem;font-weight: bold">'+error.response.data+'</div>';
                        }

                    } catch(err) {
                        console.log(err.response.data.message)
                    }
                });
            },

            axios_getBedStatus1 (){ //表格內說明文字1 BEDSTATUS1
                this.bedStatus1 = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/BEDSTATUS1/ALLCODE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.bedStatus1+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.bedStatus1 = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.bedStatus1 = '';
                    } catch(err) {
                        this.bedStatus1 = '';
                    }
                });
            },

            axios_getBedStatus2 (){ //表格外說明文字2 BEDSTATUS2
                this.bedStatus2 = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/BEDSTATUS2/ALLCODE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.bedStatus2+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.bedStatus2 = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.bedStatus2 = '';
                    } catch(err) {
                        this.bedStatus2 = '';
                    }
                });
            },
        }
    }
</script>

<style scoped>


</style>